import type { ComponentType } from "react"
import { Helmet as ReactHelmet, type HelmetProps } from "react-helmet"

// @types/react-helmet@6.1.11 still declares Helmet as React.Component<HelmetProps, {}>,
// which is not assignable to Component<any, any, any> under React 18 types (missing
// `refs`). The unknown cast is unavoidable until we move to react-helmet-async.
const Helmet = ReactHelmet as unknown as ComponentType<HelmetProps>

export default Helmet
